<div class="card">
    <div class="card-header">
        Reporting to Employee
    </div>
    <div class="card-body" style="overflow : auto">
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Type:</label>
            </div>
            <div class="col px-1">
                <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Front"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Front
                </label>
                &nbsp;&nbsp;&nbsp; &nbsp;&nbsp; <label class="form-check-label link-dark px-1 text-label-light">
                    <input class="form-check-input" type="radio" name="EmployeeType" value="Back"
                        [(ngModel)]="EmployeeType" (click)="onSelectionChange('EmployeeType',$event)"> Back
                </label>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Branch:<span class="text-danger">*</span></label>
            </div>
            <div class="col-md-4 px-1">
                <ng-select name="branch" [items]="BranchMaster" bindLabel="BranchName" bindValue="BranchMasterID"
                    [(ngModel)]="BranchId" (change)=" onSelectChange('Branch'); ComboLoad('Client')"
                    placeholder="Select Branch">
                    <ng-option *ngFor="let segment of BranchMaster" [value]="segment.BranchMasterID">
                        {{ segment.BranchName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1" *ngIf="EmployeeType === 'Front'">
            <div class="col-md-2 px-1">
                <label class="Label">Client:</label>
            </div>
            <div class="col-md-7 px-1">
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId"
                    (change)="onSelectChange('Client'); ComboLoad('Site')" placeholder="Select Client">
                    <ng-option *ngFor="let segment of ClientLoad" [value]="segment.ClientGroupMasterID">
                        {{ segment.ClientGroupName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1" *ngIf="EmployeeType === 'Front'">
            <div class="col-md-2 px-1">
                <label class="Label">Site:</label>
            </div>
            <div class="col-md-7 px-1">
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" (change)="onSelectChange('Site');" placeholder="Select Site">
                    <ng-option *ngFor="let segment of SiteLoad" [value]="segment.SiteMasterID">
                        {{ segment.SiteName }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
        <div class="row m-1">
            <div class="col-md-2 px-1">
                <label class="Label">Employee Code:</label>
            </div>
            <div class="col-md-2 px-1">
                <input name="Employeecode" type="text" [(ngModel)]="EmployeeCode" (keypress)="onChange()"
                    class="form-control" placeholder="Employee Code" />
            </div>
            <div class="col-md-2 px-1">
                <button class="btn btn-primary" name="search" (click)="Search()">
                    <i class="bi bi-search" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Search':'Loading...'}}
                </button>
            </div>
            <div class="col px-1"></div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="Apply" [disabled]="ReportingToData.length === 0"
                    (click)="DefaultToAll()"
                    [ngClass]="{'btn-secondary': ReportingToData.length === 0, 'btn-primary': ReportingToData.length > 0}">
                    <i class="bi bi-chevron-double-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Apply to All':'Loading...'}}
                </button>
            </div>
        </div>

        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col">#</th>
                    <th scope="col" style="width: 5px;">
                        <input type="checkbox" name="all" (change)="selectAll($event)" [(ngModel)]="allSelect">
                    </th>
                    <th scope="col" style="display: none;"> Branch Name</th>
                    <th scope="col" style="display: none;"> Employee Type</th>
                    <th scope="col" style="display: none;">Client ID</th>
                    <th scope="col" *ngIf="EmployeeType === 'Front'">Client Name</th>
                    <th scope="col" style="display: none;">Site ID</th>
                    <th scope="col" style="display: none;">Site Code</th>
                    <th scope="col" *ngIf="EmployeeType === 'Front'">Site Name</th>
                    <th scope="col" style="display: none;">Employee ID</th>
                    <th scope="col">Employee Code</th>
                    <th scope="col">Employee Name</th>
                    <th scope="col" class="narrow-column">Reporting Approval1</th>
                    <th scope="col" class="narrow-column">Reporting Approval2</th>
                    <th scope="col" class="narrow-column">Shift</th>
                    <th scope="col" class="narrow-column">Department</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let site of ReportingToData; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>
                        <input type="checkbox" [(ngModel)]="site.selected" name="row{{i}}" (click)="resetSelection()">
                    </td>
                    <td style="display: none;">{{ site['Branch'] }}</td>
                    <td style="display: none;">{{ site['EmpType'] }}</td>
                    <td style="display: none;">{{ site['ClientGroupMasterID'] }}</td>
                    <td *ngIf="EmployeeType === 'Front'">{{ site['ClientGroupName'] }}</td>
                    <td style="display: none;">{{ site['SiteMasterID'] }}</td>
                    <td style="display: none;">{{ site['SiteCode'] }}</td>
                    <td *ngIf="EmployeeType === 'Front'">{{ site['SiteName'] }}</td>
                    <td style="display: none;">{{ site['EmpMasterID'] }}</td>
                    <td>{{ site['EmpCode'] }}</td>
                    <td>{{ site['FirstName'] }}</td>
                    <td class="narrow-column">
                        <ng-select name="reportmanager1{{i}}" [items]="UserLoad" bindLabel="UserName"
                            bindValue="UserMasterId" [(ngModel)]="site.ReportingManagerId1" placeholder=" ">
                        </ng-select>
                    </td>
                    <td class="narrow-column">
                        <ng-select name="reportmanager2{{i}}" [items]="UserLoad" bindLabel="UserName"
                            bindValue="UserMasterId" [(ngModel)]="site.ReportingManagerId2" placeholder=" ">
                        </ng-select>
                    </td>
                    <td class="narrow-column">
                        <ng-select name="Shift{{i}}" [items]="Shift" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                            [(ngModel)]="site.ShiftMasterID" placeholder=" ">
                        </ng-select>
                    </td>
                    <td class="narrow-column">
                        <ng-select name="Department{{i}}" [(ngModel)]="site.DepartmentID">
                            <ng-option *ngFor="let manager of DepartmentLoad" [value]="manager.DepartmentMasterID">
                                {{ manager.DepartmentName }}
                            </ng-option>
                        </ng-select>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-primary" name="save" (click)="save()" *ngIf="this.common.PageRight.IsEdit">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>